import React from "react";
import {
  Card as BootstrapCard,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Anchor from "./Anchor";
import AnchorButton from "./AnchorButton";
import { longDateFormat } from "../utils/dates";

const images = require.context("../assets", true);

const Card = (props) => {
  const description = props.data.description || props.data.excerpt;
  const title = props.data.title;

  const blogUrl = props.data.slug
    ? `/blog/post/${props.data.slug}`
    : null;

  const url = props.data.button ? props.data.button.url : blogUrl;
  const buttonLabel = props.data.button ? props.data.button.label : null;

  const publishDate = props.data.published_at
    ? new Date(props.data.published_at)
    : null;

  const badgeLabel = props.data.badge
    ? props.data.badge.label
    : null;

  let imagePNG, imageWEBP, imageJP2;

  if (props.data.image) {
    imagePNG = images(`./${props.data.image}.png`);
    imageWEBP = images(`./${props.data.image}.webp`);
    imageJP2 = images(`./${props.data.image}.jp2`);
  }

  return (
    <BootstrapCard>
      {props.data.image && (
        <picture>
          <source type="image/webp" srcSet={imageWEBP} />
          <source type="image/jp2" srcSet={imageJP2} />
          <BootstrapCard.Img
            variant="top"
            src={imagePNG}
            alt={props.data.alt || title}
          />
        </picture>
      )}

      {props.data.feature_image && (
        <Link to={url}>
          <BootstrapCard.Img
            variant="top"
            src={props.data.feature_image}
            alt={props.data.alt || title}
          />
        </Link>
      )}

      <BootstrapCard.Body>
        <BootstrapCard.Title>
          <Anchor to={url}>{title}</Anchor>
        </BootstrapCard.Title>

        <BootstrapCard.Text>
          <Anchor to={url}>{description}</Anchor>
        </BootstrapCard.Text>

        {buttonLabel && (
          <AnchorButton to={url}>{buttonLabel}</AnchorButton>
        )}

        {badgeLabel && (
          <span className="badge rounded-pill bg-secondary">
            {badgeLabel}
          </span>
        )}
      </BootstrapCard.Body>

      {publishDate && (
        <BootstrapCard.Footer>
          {longDateFormat(publishDate.toDateString())} |{" "}
          {props.data.reading_time} min read
        </BootstrapCard.Footer>
      )}
    </BootstrapCard>
  );
};

const CardGroup = (props) => {
  // Limit cards safely (no mutation)
  const cards = (props.cards || []).slice(0, 9);

  // Group cards into rows of 3 (no mutation)
  const cardRows = [];
  for (let i = 0; i < cards.length; i += 3) {
    cardRows.push(cards.slice(i, i + 3));
  }

  return (
    <Container>
      {cardRows.map((cardRow, rowIndex) => (
        <React.Fragment key={rowIndex}>
          <Row>
            {cardRow.map((data) => (
              <Col md={4} key={data.id} className="mb-4">
                <Card data={data} />
              </Col>
            ))}
          </Row>
          <br />
        </React.Fragment>
      ))}
    </Container>
  );
};

export default CardGroup;
